import { render, staticRenderFns } from "./dg-pdfpreview.vue?vue&type=template&id=6cfe3c21&scoped=true"
import script from "./dg-pdfpreview.vue?vue&type=script&lang=js"
export * from "./dg-pdfpreview.vue?vue&type=script&lang=js"
import style0 from "./dg-pdfpreview.vue?vue&type=style&index=0&id=6cfe3c21&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cfe3c21",
  null
  
)

export default component.exports